<template>
  <div class="main-content" :style="getBackgroundImage()">
    <b-container class="main-content__container" >
      <slot></slot>
    </b-container>
  </div>
</template>
<script>
import NavbarSplitter from "@/components/NavbarSplitter";
import DayBanner from "@/assets/login/ESH_Web_banner_day.png";
import NightBanner from "@/assets/login/ESH_Web_banner_night.png";
export default {
  components: { 
    NavbarSplitter,
    DayBanner,
    NightBanner
  },
  data() {
    return {
      dayImage: { backgroundImage: `url(${require('@/assets/login/ESH_Web_banner_day.png')})` },
      nightImage: { backgroundImage: `url(${require('@/assets/login/ESH_Web_banner_night.png')})` }
    }
  },
  methods: {
    getBackgroundImage() {
      var nowTime = moment().hour()
      if(nowTime >= 6 && nowTime < 18) return this.dayImage;
      else return this.nightImage;
    }
  }
};
</script>
